// Tek kaynak: backend kökünü çöz.
// Kural: build sırasında gömülü değer bir Emergent PREVIEW adresiyse ve
// uygulama preview olmayan bir host'ta (ör. sertex-ai.com) çalışıyorsa, o
// değeri YOK SAY ve aynı origin'i kullan. Böylece prod build yanlışlıkla
// preview backend'ine istek atamaz.
export function resolveBackendUrl() {
  const raw = process.env.REACT_APP_BACKEND_URL;
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const usable = raw && raw !== "undefined" && raw !== "null";
  if (!usable) return origin;

  const host = typeof window !== "undefined" ? window.location.hostname : "";
  const bakedIsPreview = /preview\.emergentagent\.com/i.test(raw);
  const runningOnPreview = /preview\.emergentagent\.com$/i.test(host) || host === "localhost";
  if (bakedIsPreview && host && !runningOnPreview) return origin;

  return raw.replace(/\/+$/, "");
}

export const BACKEND_URL = resolveBackendUrl();
